import React, { FC } from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { dealsTrns } from "src/page-components/cabinet/deals/trns";
import { Link } from "src/components/Link";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { getItemPath } from "src/utils/getItemPath";
import { PATHNAMES } from "src/constants/routes";
import { ReactComponent as MessageIcon } from "src/assets/icons/message.svg";

interface Props {
  className?: string;
  chatId: number;
  isActiveStatus: boolean;
  isHiddenLabel?: boolean;
}

export const ButtonChat: FC<Props> = ({
  className,
  chatId,
  isActiveStatus,
  isHiddenLabel,
}) => {
  const { t } = useTranslation();

  return (
    <Link
      className={cn("flex-1 w-full", className)}
      href={getItemPath(PATHNAMES.CHAT_ITEM, { id: chatId })}
      isDisabled={!isActiveStatus}
    >
      <Button
        className="flex-1 gap-2.5 px-8 w-full py-4 font-medium"
        variant={
          isActiveStatus ? ButtonVariants.PRIMARY : ButtonVariants.SECONDARY
        }
      >
        <MessageIcon
          className={cn("w-6 h-6", {
            "fill-svg-white-base": isActiveStatus,
            "fill-svg-purple-base": !isActiveStatus,
          })}
        />
        {!isHiddenLabel && <span>{t(dealsTrns.chatButton)}</span>}
        
      </Button>
    </Link>
  );
};
